<template>
	<v-text-field
		browser-autocomplete="off"
		:name="generatedName"
		ref="tex"
		:disabled="disabled"
		:label=label
		:placeholder=placeholder
		:error-messages="errorMessages"
		:rules="rules"
		v-model="editedValue"
		@focus="focus"
		@blur="blur"
		@keydown="keyDown"
		:prefix="prefix"
		:suffix="suffix"
		data-vv-scope="scope1"
		validate-on-blur
		@input="save"
		aria-label="number input field"
		:prepend-icon="prependIcon"
	>
	</v-text-field>
</template>

<script>
	export default {
		name: "egrantyNumberInputField",

		data() {
			return {
				counter: 0,
				timeStamp: null,
				interval: undefined,
				keydown: false,
				editedValue: "",
				htmlElement: null,
				previousIndex: null,
				setIndex: false,
				spaceCounter: 0,
				indexCounter: 0,
				focusFlag: false,
				generatedName: "",
				errorMessages: "",
				basicValidationRules: {
					validate: function (value) {
						if (value && value.toString().includes(".")) {
							return "Miejsca dziesiętne należy oddzielić przecinkiem";
						}
						let temp = null;
						if (value) {
							temp = String(value).replace(",", ".");
							while(temp.indexOf(" ") > 0) {
								temp = temp.replace(" ", "");
							}
						}
						if (isNaN(temp)) {
							return "Proszę wpisać prawidłową liczbę";
						}
						return true;
					},

					required: function (value) {
						if (value === null || value === "" || value === undefined) return "To pole jest wymagane.";
						return true;
					},
				},
			};
		},

		computed: {
			rules() {
				let array = [];
				for (let rule in this.validationRules) {
					array.push(this.validationRules[rule]);
				}
				array.push(this.basicValidationRules.validate);
				if (this.required) {
					array.push(this.basicValidationRules.required);
				}
				return array;
			},
		},
		methods: {

			keyDown(event) {
				const checkListA = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ',', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Backspace', 'Tab'];
				const checkListB = ["Backspace", "ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown", "Tab"];
				const checkListC = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

				// zapewnia max 20 znaków (19 cyfr + przecinek)
				if (this.focusFlag && checkListC.includes(event.key)) {
					let parts = this.editedValue.split(",");
					if (parts[0].replace(/ /g, "").length >= 17 && (parts.length < 2 || parts[1].length < 2 && this.htmlElement.selectionStart <= this.editedValue.indexOf(','))) {
						event.preventDefault(); // nie można pisać więcej niż 17 znaków przed przecinkiem, gdy nie ma przecinka lub część ułamkowa ma mniej niż 2 znaki
						return;
					}
					if (this.editedValue.replace(/ /g, "").length > 19) {
						event.preventDefault(); // nie można pisać więcej niż 19 znaków
						return;
					}
				}

				// zapewnia, że nie można skasować przecinka, jeżeli liczba całkowita ma > 15 znaków, inaczej poprzez automatyczne dodanie ',00' można przekroczyć limit
				if (this.focusFlag && event.key === "Backspace" && this.editedValue.split(",")[0].replace(/ /g, "").length > 15 &&
					this.editedValue[this.htmlElement.selectionStart - 1] === ',') {
					event.preventDefault();
					return;
				}

				if (this.focusFlag && event.key === "Backspace" && this.editedValue[this.htmlElement.selectionStart-1] === ' ') {
					event.preventDefault();
					return;
				}

				if (this.focusFlag && event.key === ',' && this.editedValue.indexOf(',')>-1) {
					event.preventDefault();
					return;
				}

				if (!(checkListA.includes(event.key)) && this.focusFlag) {
					event.preventDefault();
					return;
				}

				if (this.focusFlag && this.editedValue.indexOf(',') > -1 && this.htmlElement.selectionStart > this.editedValue.indexOf(',') && (this.editedValue.length === (this.editedValue.indexOf(',') + 1 + this.fractionalLen) && !checkListB.includes(event.key))) {
					event.preventDefault();
				}

			},
			async save(val) {
				// sprawdzamy czy przypadkiem nie zostalo cos innego wlaczone niz kropka, przecinek lub cyfra
				if (val[0] === ' ') {
					val = val.substring(1, val.length);
					this.nextTick(val);
					await this.setCaret(0);
					return;
				}

				if (this.htmlElement && this.htmlElement.selectionStart && this.indexCounter === 0) {
					this.timeStamp = Date.now();
					this.previousIndex = this.htmlElement.selectionStart;
					// liczymy spacje
					for (let i = 0; i < val.length; i++) {
						if (val[i] === ' ') {
							this.spaceCounter = this.spaceCounter + 1;
						}
					}
					if (!this.doubleMechanism) {
						this.indexCounter = 2;
					} else {
						this.indexCounter = 1;
					}
				}

				// usuwamy wszystkie spacje zeby przeliczyc je od nowa
				while(val.indexOf(" ") > 0) {
					val = val.replace(" ", "");
				}
				// jak ktos sie pomyli i wcisnie kropke, to zmieniamy na przecinek
				val = val.replace(".", ",");
				if (val.indexOf(',') === 0) {
					val = "0" + val;
				}

				// w przypadku wiecej niz jednego przecinka, po prostu usuwamy następny
				if ((val.match(/,/g) || []).length > 1) {
					val = val.slice(0, val.indexOf(",")) + val.slice(val.indexOf(",") + 1);
				}

				// w przypadku gdy ktos zaczal od zera, to nastepnym znakiem musi byc liczba
				if (val && val.length >=2 && val[0] === '0' && val[1] !== ',') {
					val = val.substring(1, val.length);
				}

				// nie pozwalamy na wpisanie wiecej niz dwoch znakow po przecinu
				if (val.indexOf(",") > 0 && val.indexOf(",") < val.length - 1 - this.fractionalLen) {
					val = val.substring(0, val.indexOf(",") + 1 + this.fractionalLen);
				}

				val = this.doFormatting(val);
				if (this.indexCounter === 2) {
					let afterSpaceCounter = 0;
					for(let i = 0; i < val.length ; i++) {
						if (val[i] === ' ') {
							afterSpaceCounter = afterSpaceCounter + 1;
						}
					}
					let indexPosition = this.previousIndex + (afterSpaceCounter - this.spaceCounter);
					await this.setCaret(indexPosition);
					this.previousIndex = null;
					this.indexCounter = 0;
					this.spaceCounter = 0;
					this.timeStamp = null;
				}

				// dodajemy coś na końcu i usuwamy, żeby VUE skumało, że zaszły zmiany
				await this.nextTick(val);

				if (this.previousIndex !== null && this.indexCounter === 1) {
					this.indexCounter = 2;
				}

				val = this.clearForEmit(val);

				this.$emit("input", val.replace(',','.'));
				this.$emit("update:valid", this.validate(val) === true);
			},

			clearForEmit(val) {
				while(val.indexOf(" ") > 0) {
					val = val.replace(" ", "");
				}
				return val;
			},

			async nextTick(val) {
				this.editedValue = val + "_dummy";
				await this.$nextTick().then(() =>{this.editedValue = this.editedValue.replace("_dummy", "");});
			},

			focus() {
				this.focusFlag = true;
				this.previousIndex = null;
				this.indexCounter = 0;
				this.spaceCounter = 0;
				this.timeStamp = null;
			},

			doFormatting(val) {
				// mogą być cztery sytuacje A) 1234,22  B) 1234,2 C) 1234, D) 1234
				let index = null;

				if (val.indexOf(',') < 0 ) {
					index = val.length - 1;
				} else {
					index = val.indexOf(',') - 1;
				}
				while(index - 3 >= 0) {
					index = index - 3;
					val = val.substring(0, index+1).concat(" ").concat(val.substring(index+1, val.length));
				}
				return val;
			},

			blur() {
				this.addComma();
				this.focusFlag = false;
				this.previousIndex = null;
				this.indexCounter = 0;
				this.spaceCounter = 0;
				this.timeStamp = null;
				this.$emit('bl');
			},

			addComma() {
				if (this.editedValue && this.editedValue === '0' && !this.disabled){
					return;
				}
				if (this.editedValue && this.editedValue.indexOf("dummy") >= 0 && this.editedValue.indexOf(',') < 0) {
					this.editedValue = this.editedValue.split('_')[0] + ",00" + "_" + this.editedValue.split("_")[1];
				}
				if (this.editedValue && this.editedValue.length > 0 && this.editedValue.indexOf(',') < 0 && this.editedValue.indexOf('dummy') < 0) {
					this.editedValue = this.editedValue.concat(",00");
					return;
				}
				if (this.editedValue && this.editedValue.indexOf(',') > 0 && this.editedValue.indexOf('dummy') < 0 &&  this.editedValue.indexOf(',') === this.editedValue.length -2) {
					this.editedValue = this.editedValue.concat("0");
				}
				if (this.editedValue && this.editedValue.indexOf(',') > 0 && this.editedValue.indexOf(',') === this.editedValue.length -1) {
					this.editedValue = this.editedValue.concat("00");
				}
			},

			async fixField() {
				if (this.focusFlag && this.timeStamp !== null && (Date.now() - this.timeStamp) >= 40) {
					await this.setCaret(0);
					this.previousIndex = null;
					this.indexCounter = 0;
					this.spaceCounter = 0;
					this.timeStamp = null;
				}
			},

			async validate(val) {
				let valid = true;
				for (let ruleName in this.rules) {
					valid &= await this.rules[ruleName](val) === true;
				}
				return valid;
			},

			async setCaret(position) {
				await this.$refs.tex.setCaretPosition(position);
			}
		},

		updated() {
			if (!this.focusFlag && this.counter < 10) {
				this.counter = this.counter + 1;
				this.addComma();
			}
		},

		async mounted() {
			this.htmlElement = await document.getElementsByName(this.generatedName)[0];
			this.addComma();
		},

		async created() {
			this.generatedName = Math.random().toString().substring(0,12);
			this.interval = setInterval(() => this.fixField(), 40);
		},

		watch: {
			value: {
				immediate: true,
				async handler(val) {
					if (val) {
						let a = String(val);
						await this.save(a);
					} else {
						this.editedValue = "0";
					}
					this.$emit("update:valid", await this.validate(val) === true);
				},
			},
		},


		props: {
			prependIcon: {type: String, default: ""},
			disabled: {default: false},
			doubleMechanism: {
				type: Boolean,
				default: true
			},
			value: {},
			label: String,
			valid: Boolean,
			placeholder: String,
			required: {
				type: Boolean,
				default: true,
			},
			validationRules: {
				default() {
					return [];
				},
			},
			prefix: {
				type: String,
				default: "",
			},
			suffix: {
				type: String,
				default: "",
			},
			fractionalLen: {
				type: Number,
				default: 2
			}
		},
	};
</script>

<style scoped>
	.item {
		max-width: 300px;
		margin: 30px;
	}
</style>
